















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop, PropSync } from 'vue-property-decorator';
import * as FORM_INTERFACE from '../interfaces/accessTicket.interface';
import * as rules from '@/modules/shared/shared/domain/rules';

@Component({
    components: {},
})
export default class Task extends Vue {
    @Prop()
    isFormComplete!: number;
    @Prop({ default: {} })
    formValues!: {
        taskTypes: {
            value: number;
            text: string;
            description: string;
        }[];
    };
    rules: any = rules;
    $refs!: {
        form: any;
    };

    @PropSync('oldItem', {
        default: function() {
            return {} as FORM_INTERFACE.tasksInterface;
        },
    })
    task!: FORM_INTERFACE.tasksInterface;

    @Watch('isFormComplete')
    sendData(value: boolean, oldValue: boolean) {
        this.$emit('receiveData', this.task);
    }

    get isDoneByDayco() {
        return this.task.person === 1;
    }

    @Watch('task.person')
    resetForm() {
        this.$emit('resetValidation');
    }
}
